export const INITIAL = 'initial'
export const ERROR = 'error'
export const DEFAULT = 'default'
export const ABORT_PROMPT = 'abortPrompt'
export const REEDIT_CANCELLED_PROMPT = 'reEditCancelledPrompt'
export const INFO_PROMPT = 'infoPrompt'
